import jQuery from 'jquery';
import jQueryUi from 'jquery-ui';

jQuery.widget('ep.scrolltop', {
	options: {
		offset: 2,
		classes: {
			widgetClass: 'ep-scrolltop',
			visibleClass: 'scrolltop-visible',
			button: 'scrolltop-button'
		},
		texts: {
			button: __('scrolltop.button.text')
		},
		animationTime: 1000,
		scrollTarget: 0
	},
	_create: function(){
		this._$window = $(window);

		this.element.addClass(this.options.classes.widgetClass);
		
		this._setUpHtml();
		this._setUpOffsetListener();
		this._setUpButtonListener();
		
		this._isVisible = false;
	},
	_setUpHtml: function(){
		const options = this.options;
		
		const button = jQuery('<button><i class="fa fa-chevron-circle-up" aria-hidden="true"></i></button>');
		button.addClass(options.classes.button);
		button.attr('title', options.texts.button);
		
		this._button = button;
		
		this.element.append(button);
	},
	_setUpOffsetListener: function(){
		this._on(window, {
			scroll: '_onScroll'
		});
	},
	_setUpButtonListener: function(){
		this._on(this._button, {
			'click': '_onClick'
		});
	},
	_onScroll: function(event){
		this.refresh();
	},
	getBreakpoint: function(){
		const windowHeight = this._$window.height();
		return windowHeight*this.options.offset;
	},
	shouldBeVisible: function(){
		const currentScrollTop = this._$window.scrollTop();
		return currentScrollTop >=  this.getBreakpoint();
	},
	refresh: function(){
		const shouldBeVisible = this.shouldBeVisible();
		
		if(this._isVisible !== shouldBeVisible){
			this._updateVisibility(shouldBeVisible);
		}
	},
	_updateVisibility: function(show){
		const visibleClass = this.options.classes.visibleClass;
		if(show){
			this.element.addClass(visibleClass);
		}else{
			this.element.removeClass(visibleClass);
		}
		this._isVisible = show;
	},
	_onClick: function(){
		const options = this.options;
		
		jQuery('html, body').animate({
			scrollTop: options.scrollTarget
		}, options.animationTime);
	}
});

export default function(){
	jQuery(function(){
		jQuery('body').scrolltop();
	});
}